An opaque cursor to the later bounding webhook subscription.

Resulting webhook subscriptions will _precede_ this cursor.
